import { useDataFetch } from "./Use-data-fetch";

/**
 * Valor del punto del país, tal como está guardado en países disponibles.
 *
 * Es lo que convierte puntos a dinero en las vistas de bonos; vivía duplicado
 * dentro de LoyaltyModern.
 */
export const usePointValue = (currency = "COP") => {
  const { getData } = useDataFetch();

  const { data: countriesData } = getData(
    ["countries-available"],
    "/product/countries-available/all",
    {
      staleTime: 30 * 60 * 1000,
    }
  );

  const countries = countriesData?.data?.countries || [];

  const country = countries.find((item) => item.currency === currency);

  return country?.pointValue || 0;
};

export default usePointValue;
